import { createStore } from 'redux';

import { getInstance as getDynamicReducerInstance } from 'lib/DynamicReducer/singleton';

let storeInstance;

export function createStoreInstance(initialState = {}, history) {
    const dynamicReducer = getDynamicReducerInstance();

    const reducer = dynamicReducer.createReducer();

    storeInstance = createStore(reducer, initialState);

    return storeInstance;
}

export function getInstance() {
    if (!storeInstance) {
        storeInstance = createStoreInstance();
    }
    return storeInstance;
}

// Can only destroy the instance in tests
export function destroyInstance() {
    if (__TESTING__) {
        storeInstance = null;
    }
}
